import type { CSSProperties } from 'react';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
  'aria-hidden'?: boolean;
}

/**
 * Visual placeholder for content that's still loading. Pairs with `role="status"`
 * regions where appropriate. Honors prefers-reduced-motion (shimmer disabled).
 *
 * Width/height/radius accept numbers (px) or any CSS length string. When a
 * dimension is omitted the consumer's layout decides — e.g. a Skeleton inside
 * a flex row will fill the row.
 */
export function Skeleton({
  width,
  height,
  radius,
  className,
  ...rest
}: SkeletonProps) {
  const style: CSSProperties = {};
  if (width !== undefined) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height !== undefined) style.height = typeof height === 'number' ? `${height}px` : height;
  if (radius !== undefined) style.borderRadius = typeof radius === 'number' ? `${radius}px` : radius;
  const cls = ['pn-skeleton', className].filter(Boolean).join(' ');
  return <span className={cls} style={style} aria-hidden={rest['aria-hidden'] ?? true} />;
}
